"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkGiftCertificateV2Capability = exports.LinkGiftCertificateV2Closed = exports.LinkGiftCertificateV2Enabled = exports.LINK_GIFT_CERTIFICATE_V2_ANSWERS = exports.LinkGiftCertificateV2AckRefused = exports.LinkGiftCertificateV2Ack = exports.LinkGiftCertificateV2Released = exports.LinkGiftCertificateV2Voided = exports.LinkGiftCertificateV2StateUnknown = exports.LinkGiftCertificateV2CancelOk = exports.LinkGiftCertificateV2LockOk = exports.LinkGiftCertificateV2Unsent = exports.LinkGiftCertificateV2Admitted = exports.LinkGiftCertificateV2VoidCause = exports.LinkGiftCertificateV2UnknownCause = exports.LinkGiftCertificateV2UnsentCause = exports.LinkGiftCertificateRequestRefused = exports.LinkGiftCertificateAckRequest = exports.LinkGiftCertificateAckStage = exports.LinkGiftCertificateExecuteRequest = exports.LinkGiftCertificateAdmitCancelRequest = exports.LinkGiftCertificateAdmitLockRequest = exports.LINK_GIFT_CERTIFICATE_V2_M1_OPERATIONS = exports.LinkGiftCertificateWallTime = exports.LinkGiftCertificateNumber = exports.LinkGiftCertificateUuid = exports.LINK_GIFT_CERTIFICATE_RELEASE_DISABLED = exports.LinkGiftCertificateStatusView = exports.LinkGiftCertificateEnablementView = exports.LinkGiftCertificateEnablementCreate = exports.LinkGiftCertificateStatus = exports.LinkGiftCertificateReleaseAnswer = exports.LinkGiftCertificateEnablementAnswer = exports.LinkGiftCertificateReleaseItem = exports.LinkGiftCertificateEnablementRequest = exports.LINK_GIFT_CERTIFICATE_MAX_REQUESTS = exports.LINK_GIFT_CERTIFICATE_V1_ANSWER = exports.LinkGiftCertificateVersionUnsupported = exports.LINK_GIFT_CERTIFICATE_V1_STATUS = exports.LINK_GIFT_CERTIFICATE_DISABLED_ANSWER = exports.LinkGiftCertificateUnsentAnswer = exports.LinkGiftCertificateUnsentCause = exports.LinkGiftCertificateCapabilities = exports.LinkGiftCertificateLegacyData = exports.LinkGiftCertificateMode = exports.LINK_GIFT_CERTIFICATE_V2_PATHS = exports.LINK_GIFT_CERTIFICATE_V1_PREFIX = exports.LINK_GIFT_CERTIFICATE_V2_PREFIX = exports.LINK_GIFT_CERTIFICATE_PROTOCOL = void 0;
exports.linkGiftCertificateAttemptAckPath = linkGiftCertificateAttemptAckPath;
exports.linkGiftCertificateAttemptPath = linkGiftCertificateAttemptPath;
exports.linkGiftCertificateAttemptExecutePath = linkGiftCertificateAttemptExecutePath;
exports.buildLinkGiftCertificateAdmitLockRequest = buildLinkGiftCertificateAdmitLockRequest;
exports.buildLinkGiftCertificateAdmitCancelRequest = buildLinkGiftCertificateAdmitCancelRequest;
exports.buildLinkGiftCertificateExecuteRequest = buildLinkGiftCertificateExecuteRequest;
exports.buildLinkGiftCertificateAckRequest = buildLinkGiftCertificateAckRequest;
exports.readLinkGiftCertificateGuardRefusal = readLinkGiftCertificateGuardRefusal;
const zod_1 = require("zod");
/**
 * VL-378 — gift certificates between till, Link and Back Office: protocol 2,
 * as the DISABLED scaffold serves it.
 *
 * ------------------------------------------------------------------
 * WHAT THIS BUILD CAN DO: NOTHING THAT REACHES THE VENDOR
 * ------------------------------------------------------------------
 * No Link built from this source can call the certificate processing
 * database. Every certificate route on the Link answers at "step 0", right
 * after the store-pass guard and before anything certificate-related is read
 * or written:
 *
 * - every `/v2/certificates/…` operation (sale lock, payment lock, their
 *   cancels, an attempt ACK, any other path or method under the prefix) is
 *   answered `{protocol: 2, outcome: 'unsent', cause: 'certificates_disabled'}`
 *   — a definite "this request was not sent", about THIS request only;
 * - `GET /v2/certificates/capabilities` answers the mode block below;
 * - anything under the protocol-1 prefix `/certificates` is HTTP 410
 *   `{code: 'version_unsupported'}`.
 *
 * The protocol-1 path constants are NOT part of this contract any more; they
 * exist only as test fixtures.
 *
 * ------------------------------------------------------------------
 * UNKNOWN MEANS CLOSED
 * ------------------------------------------------------------------
 * Every schema here is strict and every enum closed: a mode, outcome or cause
 * this build does not know is a parse failure, and a reader treats a parse
 * failure as "no answer". It is never turned into `unsent`, and never into
 * "certificates available". An `unsent` answer never resolves, clears or
 * re-labels an earlier attempt whose outcome is unknown.
 *
 * ------------------------------------------------------------------
 * PARITY
 * ------------------------------------------------------------------
 * The till's copy is `reform_lite_contracts/lib/src/link_gift_certificates_v2.dart`
 * (C-01): same paths, same bodies, same closed enums.
 */
/** The certificate protocol this contract describes. */
exports.LINK_GIFT_CERTIFICATE_PROTOCOL = 2;
/** Every protocol-2 certificate route lives under this prefix. */
exports.LINK_GIFT_CERTIFICATE_V2_PREFIX = '/v2/certificates';
/** The protocol-1 prefix; every path under it answers 410. */
exports.LINK_GIFT_CERTIFICATE_V1_PREFIX = '/certificates';
/** The protocol-2 routes (the operations are refused at step 0 in this build). */
exports.LINK_GIFT_CERTIFICATE_V2_PATHS = {
    saleLock: '/v2/certificates/sale-lock',
    saleLockCancel: '/v2/certificates/sale-lock/cancel',
    paymentLock: '/v2/certificates/payment-lock',
    paymentLockCancel: '/v2/certificates/payment-lock/cancel',
    capabilities: '/v2/certificates/capabilities',
};
/** `POST /v2/certificates/attempts/{recordId}/ack` (refused at step 0 in this build). */
function linkGiftCertificateAttemptAckPath(recordId) {
    return `${exports.LINK_GIFT_CERTIFICATE_V2_PREFIX}/attempts/${encodeURIComponent(recordId)}/ack`;
}
/**
 * The certificate mode a Link runs in. This build knows exactly one. A Link
 * that some day reports another mode is unreadable to this reader, and
 * unreadable is "certificates unavailable".
 */
exports.LinkGiftCertificateMode = zod_1.z.enum(['disabled']);
/**
 * What a Link knows about the certificate data an older build may have left
 * in its database. This build never looks (`not_inspected`): it neither reads
 * nor clears what is there.
 */
exports.LinkGiftCertificateLegacyData = zod_1.z.enum(['not_inspected']);
/** The Link build id a capability names (`build-info.json`'s `buildRef`), or null unpackaged. */
const BuildId = zod_1.z.string().min(1).max(128).nullable();
/**
 * `GET /v2/certificates/capabilities`, and the `certificates` block of the
 * Link status report. Built from constants and two flags; it reads no
 * certificate table.
 *
 * - `buildCanDispatch` is `false` in every build from this source, and it
 *   overrides every flag: a Link that reports `false` makes no certificate
 *   call, whatever `enablementRequested` says.
 * - `enablementRequested`: someone asked for certificates (the Link's
 *   `LINK_CERTIFICATES_MODE=enabled`, or a Back Office enablement request this
 *   process received). It changes nothing in this build.
 * - `ledgerEpoch` is null: this build has no certificate ledger.
 */
exports.LinkGiftCertificateCapabilities = zod_1.z
    .object({
    protocol: zod_1.z.literal(exports.LINK_GIFT_CERTIFICATE_PROTOCOL),
    mode: exports.LinkGiftCertificateMode,
    buildCanDispatch: zod_1.z.literal(false),
    ledgerEpoch: zod_1.z.null(),
    enablementRequested: zod_1.z.boolean(),
    legacyData: exports.LinkGiftCertificateLegacyData,
})
    .strict();
/** Why a protocol-2 operation was not sent. This build has one cause. */
exports.LinkGiftCertificateUnsentCause = zod_1.z.enum(['certificates_disabled']);
/**
 * The answer to every protocol-2 operation in this build (HTTP 200). It says
 * THIS request was not sent to the vendor. It says nothing about any earlier
 * request.
 */
exports.LinkGiftCertificateUnsentAnswer = zod_1.z
    .object({
    protocol: zod_1.z.literal(exports.LINK_GIFT_CERTIFICATE_PROTOCOL),
    outcome: zod_1.z.literal('unsent'),
    cause: exports.LinkGiftCertificateUnsentCause,
})
    .strict();
/** The one answer body every protocol-2 operation gets from this build. */
exports.LINK_GIFT_CERTIFICATE_DISABLED_ANSWER = Object.freeze({ protocol: exports.LINK_GIFT_CERTIFICATE_PROTOCOL, outcome: 'unsent', cause: 'certificates_disabled' });
/** HTTP status of everything under the protocol-1 prefix. */
exports.LINK_GIFT_CERTIFICATE_V1_STATUS = 410;
/** The body of that 410. */
exports.LinkGiftCertificateVersionUnsupported = zod_1.z
    .object({
    statusCode: zod_1.z.literal(exports.LINK_GIFT_CERTIFICATE_V1_STATUS),
    message: zod_1.z.literal('Gone'),
    code: zod_1.z.literal('version_unsupported'),
})
    .strict();
exports.LINK_GIFT_CERTIFICATE_V1_ANSWER = Object.freeze({
    statusCode: exports.LINK_GIFT_CERTIFICATE_V1_STATUS,
    message: 'Gone',
    code: 'version_unsupported',
});
// ------------------------------------------------------------------
// Link ⇄ Back Office: the status report and its answer
// ------------------------------------------------------------------
const RequestId = zod_1.z.string().min(1).max(128);
/** Most enablement requests or release commands handed to a Link per answer. */
exports.LINK_GIFT_CERTIFICATE_MAX_REQUESTS = 20;
/**
 * Back Office → Link: an operator's request to enable certificates at this
 * store. A Link of this build records `enablementRequested` and answers
 * `unsupported_by_build`; nothing else happens, then or later.
 */
exports.LinkGiftCertificateEnablementRequest = zod_1.z.object({
    id: RequestId,
    requestedAt: zod_1.z.string().datetime(),
});
/**
 * Back Office → Link: a certificate release, in whatever shape (the
 * protocol-1 `certificateReleaseRequests` or a protocol-2 command). This
 * build reads the id and nothing else, and refuses it: `release_disabled`.
 */
exports.LinkGiftCertificateReleaseItem = zod_1.z.object({ id: RequestId }).passthrough();
/** How a Link of this build answers an enablement request. */
exports.LinkGiftCertificateEnablementAnswer = zod_1.z.enum(['unsupported_by_build']);
/** How a Link of this build answers a release. */
exports.LinkGiftCertificateReleaseAnswer = zod_1.z.enum(['release_disabled']);
/**
 * The `certificates` block of `POST /link/status`: the capability block plus
 * the Link's answers to what Back Office handed it. Optional: a Link built
 * before it sends none, and a Back Office built before it drops it.
 */
exports.LinkGiftCertificateStatus = exports.LinkGiftCertificateCapabilities.extend({
    buildId: BuildId,
    enablementAnswers: zod_1.z
        .array(zod_1.z.object({ requestId: RequestId, answer: exports.LinkGiftCertificateEnablementAnswer }).strict())
        .max(exports.LINK_GIFT_CERTIFICATE_MAX_REQUESTS * 2)
        .default([]),
    releaseAnswers: zod_1.z
        .array(zod_1.z.object({ requestId: RequestId, answer: exports.LinkGiftCertificateReleaseAnswer }).strict())
        .max(exports.LINK_GIFT_CERTIFICATE_MAX_REQUESTS * 4)
        .default([]),
}).strict();
// ------------------------------------------------------------------
// Operator view and actions (Back Office)
// ------------------------------------------------------------------
/**
 * `POST /connectors/locations/:locationId/link-status/certificates/enablement-requests`
 * (`connectors.admin`). The note is required, scrubbed and capped. The
 * request is recorded and audited and can never become effective: it is
 * bound to the build the Link reported at the time, and a build that cannot
 * dispatch ignores it for good.
 */
exports.LinkGiftCertificateEnablementCreate = zod_1.z
    .object({ note: zod_1.z.string().trim().min(1).max(500) })
    .strict();
exports.LinkGiftCertificateEnablementView = zod_1.z.object({
    id: zod_1.z.string(),
    locationId: zod_1.z.string(),
    requestedAt: zod_1.z.string().datetime(),
    requestedBy: zod_1.z.string(),
    note: zod_1.z.string(),
    boundBuildId: zod_1.z.string().nullable(),
    boundVersion: zod_1.z.string().nullable(),
    buildCanDispatch: zod_1.z.boolean().nullable(),
    linkAck: exports.LinkGiftCertificateEnablementAnswer.nullable(),
    linkAckAt: zod_1.z.string().datetime().nullable(),
});
/**
 * The gift-certificate part of the operator view of a store's Link. `null`
 * when the Link has never reported a certificate block (an older Link), or
 * when Back Office cannot read it.
 */
exports.LinkGiftCertificateStatusView = zod_1.z.object({
    mode: exports.LinkGiftCertificateMode,
    buildCanDispatch: zod_1.z.literal(false),
    buildId: zod_1.z.string().nullable(),
    enablementRequested: zod_1.z.boolean(),
    legacyData: exports.LinkGiftCertificateLegacyData,
    reportedAt: zod_1.z.string().datetime(),
});
/** Back Office's answer to any release attempt while the build cannot dispatch (HTTP 409). */
exports.LINK_GIFT_CERTIFICATE_RELEASE_DISABLED = 'release_disabled';
// ------------------------------------------------------------------
// VL-378 S1 — the protocol-2 M1 wire (payment for a sale)
// ------------------------------------------------------------------
//
// NOT SERVED AND NOT SENT. No Link built from this source answers these
// shapes: every certificate operation is still answered at step 0 with
// `LINK_GIFT_CERTIFICATE_DISABLED_ANSWER`, the capability is still the
// disabled block above, and `NoDispatchExecutor` is still the only executor.
// No till sends these requests. They are the contract the later slices are
// built against (VL-378 S0 design r2 §B), held to the till's
// `link_gift_certificates_v2.dart` by the shared vector file
// `shared-scenarios/vl378-s1-wire/vectors.json` (C-01).
//
// Every answer is `{protocol: 2, outcome, …}` with exactly the fields of its
// outcome, read only for the exchange it belongs to. Anything else does not
// parse, and a reader treats that as "no answer" — never `unsent`, never a
// refusal. Integers are JSON integers in range: SQL `int` for the vendor's
// values, the safe-integer range for generations and custody sequences. Ids
// are lower-case canonical UUIDs. The disabled-scaffold schemas above are
// unchanged; these are separate.
const SQL_INT_MAX = 2_147_483_647;
const SQL_INT_MIN = -2_147_483_648;
/** A lower-case canonical UUID (the till checks the same pattern). */
exports.LinkGiftCertificateUuid = zod_1.z
    .string()
    .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
/** The 16-digit payment number. Carried in a request body only; never stored or logged by the Link. */
exports.LinkGiftCertificateNumber = zod_1.z.string().regex(/^[0-9]{16}$/);
/** Days in [month] (1..12) of proleptic-Gregorian [year]. */
function daysInMonth(year, month) {
    if (month === 2) {
        const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
        return leap ? 29 : 28;
    }
    return [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1] ?? 0;
}
/**
 * The till's wall clock, `yyyy-MM-dd HH:mm:ss.fff`, naming a real
 * proleptic-Gregorian instant from 0001-01-01 00:00:00.000 to
 * 9999-12-31 23:59:59.999: the range of SQL Server `datetime2(3)`, the type
 * of `@Transaction_Date_Time` (VL-378 S0 design r2 §2). Validated component
 * by component, exactly as the till does (C-01). No `Date` is involved, so
 * `Date.UTC`'s two-digit-year remap cannot apply: 0099 is year 99.
 */
exports.LinkGiftCertificateWallTime = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/)
    .refine((text) => {
    const [y, mo, d, h, mi, s] = [
        text.slice(0, 4),
        text.slice(5, 7),
        text.slice(8, 10),
        text.slice(11, 13),
        text.slice(14, 16),
        text.slice(17, 19),
    ].map(Number);
    if (y < 1 || mo < 1 || mo > 12 || d < 1 || d > daysInMonth(y, mo))
        return false;
    return h <= 23 && mi <= 59 && s <= 59;
});
const SqlIntPositive = zod_1.z.number().int().min(1).max(SQL_INT_MAX);
const SqlInt = zod_1.z.number().int().min(SQL_INT_MIN).max(SQL_INT_MAX);
const Generation = zod_1.z.number().int().min(1).max(Number.MAX_SAFE_INTEGER);
function attemptPath(recordId) {
    if (!exports.LinkGiftCertificateUuid.safeParse(recordId).success) {
        throw new Error('a certificate record id is a UUID');
    }
    return `${exports.LINK_GIFT_CERTIFICATE_V2_PREFIX}/attempts/${recordId}`;
}
/** `GET /v2/certificates/attempts/{recordId}` — the bound lookup. Throws for a non-UUID id. */
function linkGiftCertificateAttemptPath(recordId) {
    return attemptPath(recordId);
}
/** `POST /v2/certificates/attempts/{recordId}/execute`. Throws for a non-UUID id. */
function linkGiftCertificateAttemptExecutePath(recordId) {
    return `${attemptPath(recordId)}/execute`;
}
/** The operations an enabled M1 Link lists, in this order. */
exports.LINK_GIFT_CERTIFICATE_V2_M1_OPERATIONS = ['paymentLock', 'paymentLockCancel'];
// ---------------------------------------------------------------- requests
/** Admit body of `POST /v2/certificates/payment-lock`. No vendor call follows admission. */
exports.LinkGiftCertificateAdmitLockRequest = zod_1.z
    .object({
    clientAttemptId: exports.LinkGiftCertificateUuid,
    custodyId: exports.LinkGiftCertificateUuid,
    custodySeq: Generation,
    certificate: exports.LinkGiftCertificateNumber,
    receiptNumber: SqlIntPositive,
    registerNumber: SqlIntPositive,
    cashierId: SqlIntPositive,
    cashierName: zod_1.z
        .string()
        .max(200)
        .refine((name) => name.trim().length > 0),
    transactionAt: exports.LinkGiftCertificateWallTime,
})
    .strict();
/** Admit body of `POST /v2/certificates/payment-lock/cancel`: `transactionAt` is the ORIGINAL lock's. */
exports.LinkGiftCertificateAdmitCancelRequest = zod_1.z
    .object({
    clientAttemptId: exports.LinkGiftCertificateUuid,
    custodyId: exports.LinkGiftCertificateUuid,
    custodySeq: Generation,
    lockId: SqlIntPositive,
    certificate: exports.LinkGiftCertificateNumber,
    transactionAt: exports.LinkGiftCertificateWallTime,
})
    .strict();
/** Body of `POST /v2/certificates/attempts/{recordId}/execute`. */
exports.LinkGiftCertificateExecuteRequest = zod_1.z
    .object({ generation: Generation, certificate: exports.LinkGiftCertificateNumber })
    .strict();
/** The stage an ack reports. */
exports.LinkGiftCertificateAckStage = zod_1.z.enum(['leg_captured', 'receipt_fiscalised']);
/** Body of `POST /v2/certificates/attempts/{recordId}/ack`, bound to the origin and the ledger. */
exports.LinkGiftCertificateAckRequest = zod_1.z
    .object({
    stage: exports.LinkGiftCertificateAckStage,
    generation: Generation,
    lockId: SqlIntPositive,
    receiptNumber: SqlIntPositive,
    ledgerEpoch: exports.LinkGiftCertificateUuid,
})
    .strict();
/**
 * A request a builder refused. It names the refused fields and nothing else:
 * no value, and no zod issue (whose texts can quote a value), is kept
 * (c314 F1: a refused certificate number must not escape through an error).
 */
class LinkGiftCertificateRequestRefused extends Error {
    constructor(fields) {
        super(`certificate request refused: ${fields.join(', ')} outside the VL-378 M1 wire contract`);
        this.fields = fields;
        this.name = 'LinkGiftCertificateRequestRefused';
    }
}
exports.LinkGiftCertificateRequestRefused = LinkGiftCertificateRequestRefused;
function admitted(schema, input) {
    const parsed = schema.safeParse(input);
    if (parsed.success)
        return parsed.data;
    const fields = parsed.error.issues.map((issue) => issue.code === 'unrecognized_keys' ? '(unknown fields)' : issue.path.join('.') || '(body)');
    throw new LinkGiftCertificateRequestRefused([...new Set(fields)]);
}
/** The admit-lock body in wire order. Throws `LinkGiftCertificateRequestRefused`, naming fields only. */
function buildLinkGiftCertificateAdmitLockRequest(input) {
    const v = admitted(exports.LinkGiftCertificateAdmitLockRequest, input);
    return {
        clientAttemptId: v.clientAttemptId,
        custodyId: v.custodyId,
        custodySeq: v.custodySeq,
        certificate: v.certificate,
        receiptNumber: v.receiptNumber,
        registerNumber: v.registerNumber,
        cashierId: v.cashierId,
        cashierName: v.cashierName,
        transactionAt: v.transactionAt,
    };
}
/** The admit-cancel body in wire order. Throws `LinkGiftCertificateRequestRefused`, naming fields only. */
function buildLinkGiftCertificateAdmitCancelRequest(input) {
    const v = admitted(exports.LinkGiftCertificateAdmitCancelRequest, input);
    return {
        clientAttemptId: v.clientAttemptId,
        custodyId: v.custodyId,
        custodySeq: v.custodySeq,
        lockId: v.lockId,
        certificate: v.certificate,
        transactionAt: v.transactionAt,
    };
}
/** The execute body in wire order. Throws `LinkGiftCertificateRequestRefused`, naming fields only. */
function buildLinkGiftCertificateExecuteRequest(input) {
    const v = admitted(exports.LinkGiftCertificateExecuteRequest, input);
    return { generation: v.generation, certificate: v.certificate };
}
/** The ack body in wire order. Throws `LinkGiftCertificateRequestRefused`, naming fields only. */
function buildLinkGiftCertificateAckRequest(input) {
    const v = admitted(exports.LinkGiftCertificateAckRequest, input);
    return {
        stage: v.stage,
        generation: v.generation,
        lockId: v.lockId,
        receiptNumber: v.receiptNumber,
        ledgerEpoch: v.ledgerEpoch,
    };
}
// ----------------------------------------------------------------- answers
const PROTOCOL = zod_1.z.literal(exports.LINK_GIFT_CERTIFICATE_PROTOCOL);
/** Why an M1 request was not sent to the vendor (separate from the disabled build's one cause). */
exports.LinkGiftCertificateV2UnsentCause = zod_1.z.enum([
    'certificates_disabled',
    'link_closed',
    'operation_not_enabled',
    'certificate_busy',
    'certificate_blocked',
    'certificate_used_here',
    'vendor_unreachable',
    'expired',
]);
/** Why an executed (or possibly executed) call's outcome is unknown — the reserved attempt exec states. */
exports.LinkGiftCertificateV2UnknownCause = zod_1.z.enum([
    'returned',
    'timed_out',
    'owner_lost',
    'owner_lost_pre_claim',
]);
/** Why an admitted record ended without a vendor effect. */
exports.LinkGiftCertificateV2VoidCause = zod_1.z.enum(['expired', 'vendor_unreachable']);
/** `admitted{recordId, generation, ledgerEpoch}`: a record exists; no vendor call was made. */
exports.LinkGiftCertificateV2Admitted = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('admitted'),
    recordId: exports.LinkGiftCertificateUuid,
    generation: Generation,
    ledgerEpoch: exports.LinkGiftCertificateUuid,
})
    .strict();
/** `unsent{cause}`: THIS request was not sent to the vendor. */
exports.LinkGiftCertificateV2Unsent = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('unsent'),
    cause: exports.LinkGiftCertificateV2UnsentCause,
})
    .strict();
/** `ok{lockId, nominal, prodId}` of a payment lock. `nominal` is the vendor's integer; its unit is open (V5). */
exports.LinkGiftCertificateV2LockOk = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('ok'),
    lockId: SqlIntPositive,
    nominal: SqlIntPositive,
    prodId: SqlInt,
})
    .strict();
/** `ok{lockId}` of a payment-lock cancel. */
exports.LinkGiftCertificateV2CancelOk = zod_1.z
    .object({ protocol: PROTOCOL, outcome: zod_1.z.literal('ok'), lockId: SqlIntPositive })
    .strict();
/** `state_unknown{cause}`: blocking. */
exports.LinkGiftCertificateV2StateUnknown = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('state_unknown'),
    cause: exports.LinkGiftCertificateV2UnknownCause,
})
    .strict();
/** `voided{cause}`: the record ended without a vendor effect. */
exports.LinkGiftCertificateV2Voided = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('voided'),
    cause: exports.LinkGiftCertificateV2VoidCause,
})
    .strict();
/** `released{generation, disposition, releaseId}`: a manual release of THAT record at THAT generation. */
exports.LinkGiftCertificateV2Released = zod_1.z
    .object({
    protocol: PROTOCOL,
    outcome: zod_1.z.literal('released'),
    generation: Generation,
    disposition: zod_1.z.enum(['available', 'consumed']),
    releaseId: exports.LinkGiftCertificateUuid,
})
    .strict();
/** `ack{custody}`. */
exports.LinkGiftCertificateV2Ack = zod_1.z
    .object({ protocol: PROTOCOL, outcome: zod_1.z.literal('ack'), custody: zod_1.z.enum(['held', 'consumed']) })
    .strict();
/** `ack_refused{conflict}`: nothing changed. */
exports.LinkGiftCertificateV2AckRefused = zod_1.z
    .object({ protocol: PROTOCOL, outcome: zod_1.z.literal('ack_refused'), cause: zod_1.z.literal('conflict') })
    .strict();
/** The answers each exchange accepts. An answer is read only for its own exchange. */
exports.LINK_GIFT_CERTIFICATE_V2_ANSWERS = {
    admit: zod_1.z.union([exports.LinkGiftCertificateV2Admitted, exports.LinkGiftCertificateV2Unsent]),
    executeLock: zod_1.z.union([
        exports.LinkGiftCertificateV2LockOk,
        exports.LinkGiftCertificateV2StateUnknown,
        exports.LinkGiftCertificateV2Unsent,
    ]),
    executeCancel: zod_1.z.union([
        exports.LinkGiftCertificateV2CancelOk,
        exports.LinkGiftCertificateV2StateUnknown,
        exports.LinkGiftCertificateV2Unsent,
    ]),
    ack: zod_1.z.union([
        exports.LinkGiftCertificateV2Ack,
        exports.LinkGiftCertificateV2AckRefused,
        exports.LinkGiftCertificateV2Unsent,
    ]),
    lookup: zod_1.z.union([
        exports.LinkGiftCertificateV2Released,
        exports.LinkGiftCertificateV2Voided,
        exports.LinkGiftCertificateV2StateUnknown,
        exports.LinkGiftCertificateV2Unsent,
    ]),
};
// ------------------------------------------------------------ capabilities
/** `enabled`: a dispatch build with a ledger, listing the M1 operations. Not served by this build. */
exports.LinkGiftCertificateV2Enabled = zod_1.z
    .object({
    protocol: PROTOCOL,
    mode: zod_1.z.literal('enabled'),
    buildCanDispatch: zod_1.z.literal(true),
    ledgerEpoch: exports.LinkGiftCertificateUuid,
    operations: zod_1.z.tuple([zod_1.z.literal('paymentLock'), zod_1.z.literal('paymentLockCancel')]),
})
    .strict();
/** `closed`: a dispatch build refusing every certificate operation. Not served by this build. */
exports.LinkGiftCertificateV2Closed = zod_1.z
    .object({
    protocol: PROTOCOL,
    mode: zod_1.z.literal('closed'),
    buildCanDispatch: zod_1.z.literal(true),
    ledgerEpoch: exports.LinkGiftCertificateUuid.nullable(),
    operations: zod_1.z.tuple([]),
})
    .strict();
/** A capability block in any of the three modes, as a till reads it. */
exports.LinkGiftCertificateV2Capability = zod_1.z.union([
    exports.LinkGiftCertificateCapabilities,
    exports.LinkGiftCertificateV2Enabled,
    exports.LinkGiftCertificateV2Closed,
]);
// ------------------------------------------------------- store-pass guard
/** The store-pass guard's own answers on the till routes: refused before any certificate handler runs. */
const GUARD_ANSWERS = {
    401: zod_1.z.union([
        zod_1.z
            .object({
            statusCode: zod_1.z.literal(401),
            message: zod_1.z.literal('Unauthorized'),
            code: zod_1.z.literal('store_pass_refused'),
        })
            .strict(),
        zod_1.z
            .object({
            statusCode: zod_1.z.literal(401),
            message: zod_1.z.literal('Unauthorized'),
            code: zod_1.z.literal('store_pass_required'),
        })
            .strict(),
    ]),
    503: zod_1.z.object({ statusCode: zod_1.z.literal(503), message: zod_1.z.literal('Service Unavailable') }).strict(),
    429: zod_1.z.object({ statusCode: zod_1.z.literal(429), message: zod_1.z.literal('Too Many Requests') }).strict(),
};
/** `body` as the guard's exact answer for HTTP `status`, or null. */
function readLinkGiftCertificateGuardRefusal(body, status) {
    switch (status) {
        case 401: {
            const parsed = GUARD_ANSWERS[401].safeParse(body);
            return parsed.success ? parsed.data.code : null;
        }
        case 503:
            return GUARD_ANSWERS[503].safeParse(body).success ? 'link_unjudged' : null;
        case 429:
            return GUARD_ANSWERS[429].safeParse(body).success ? 'rate_limited' : null;
        default:
            return null;
    }
}
//# sourceMappingURL=link-gift-certificates.js.map